import { Builder } from '@builder.io/react';
import { BUILDER_INTERACTIVE_SECTION_COMPONENTS_NAMES } from '../BuilderComponentsName';
import { S13LHRSection } from '../components/interactive-sections/S13LHR';
import { backgroundGradientOptions, textColorOptionsLimited, buttonVariantOptions } from '../utils/builderColorOptions';
import { getBackgroundColorInput, getBackgroundGradientInput, getPaddingInputs } from '../utils/builderSharedInputs';

Builder.registerComponent(S13LHRSection, {
  name: BUILDER_INTERACTIVE_SECTION_COMPONENTS_NAMES.S13LHR,
  friendlyName: 'S13 LHR',
  inputs: [
    {
      name: 'headline',
      type: 'string',
      required: true,
      defaultValue: 'Are You A Good Candidate for Laser Hair Removal?',
      friendlyName: 'Headline',
      helperText: 'Main headline text for the section. Available variables: {{clinicCount}}, {{totalReviews}}, {{stateCount}}, {{treatmentsPerMonth}}',
    },
    {
      name: 'headlineColor',
      type: 'string',
      defaultValue: 'Blue',
      enum: textColorOptionsLimited,
      friendlyName: 'Headline Color',
      helperText: 'Color for the headline text',
    },
    {
      name: 'subheadline',
      type: 'string',
      defaultValue: 'Top 5 Questions to Answer Before You Begin Laser Hair Removal',
      friendlyName: 'Subheadline',
      helperText: 'Secondary headline text below the main headline',
    },
    {
      name: 'subHeadlineColor',
      type: 'string',
      defaultValue: 'Navy',
      enum: textColorOptionsLimited,
      friendlyName: 'Subheadline Color',
      helperText: 'Color for the subheadline text',
    },
    {
      name: 'text1',
      type: 'string',
      required: true,
      defaultValue: 'When performed correctly, laser hair removal is a very effective method for removing unwanted hair. But are you a good candidate for laser hair removal? The answers to these common questions will help determine if you qualify.',
      friendlyName: 'Text 1',
      helperText: 'First paragraph of main text content for the section. Available variables: {{clinicCount}}, {{totalReviews}}, {{stateCount}}, {{treatmentsPerMonth}}',
    },
    {
      name: 'text2',
      type: 'string',
      friendlyName: 'Text 2',
      helperText: 'Second paragraph of main text content for the section (optional). Available variables: {{clinicCount}}, {{totalReviews}}, {{stateCount}}, {{treatmentsPerMonth}}',
    },
    {
      name: 'textColor',
      type: 'string',
      defaultValue: 'Navy',
      enum: textColorOptionsLimited,
      friendlyName: 'Text Color',
      helperText: 'Color for the main text content',
    },
    {
      name: 'imageSrc',
      type: 'file',
      defaultValue: 'https://cdn.builder.io/api/v1/image/assets%2F10266dac478d4c768f6b6fbe586ae30e%2Fc303de22b38248139d6efb9a21841e9a',
      allowedFileTypes: ['jpeg', 'jpg', 'png', 'webp', 'gif', 'svg'],
      friendlyName: 'Image',
      helperText: 'Upload an image or provide an image URL for the main section image',
    },
    {
      name: 'imageAltText',
      type: 'string',
      required: true,
      defaultValue: 'Laser hair removal treatment',
      friendlyName: 'Image Alt Text',
      helperText: 'Alt text for the main image',
    },
    {
      name: 'imageDisplaySide',
      type: 'boolean',
      defaultValue: false,
      friendlyName: 'Image Display Side',
      helperText: 'Toggle image position from right to left',
    },
    {
      name: 'imageSrcBadge',
      type: 'file',
      defaultValue: 'https://cdn.builder.io/api/v1/file/assets%2F10266dac478d4c768f6b6fbe586ae30e%2F3bd386d730254ea990ede4bd188d408d',
      allowedFileTypes: ['jpeg', 'jpg', 'png', 'webp', 'gif', 'svg'],
      friendlyName: 'Badge Image',
      helperText: 'Upload a badge image or provide an image URL (optional)',
    },
    {
      name: 'imageAltBadge',
      type: 'string',
      defaultValue: 'Badge Alt Text',
      friendlyName: 'Badge Image Alt Text',
      helperText: 'Alt text for the badge image',
    },
    {
      name: 'buttonDisabled',
      type: 'boolean',
      defaultValue: true,
      friendlyName: 'Show Button',
      helperText: 'Toggle to show or hide the call-to-action button',
    },
    {
      name: 'buttonLabel',
      type: 'string',
      defaultValue: 'Take Quiz',
      friendlyName: 'Button Text',
      helperText: 'Text to be displayed on the button',
    },
    {
      name: 'buttonVariant',
      type: 'string',
      required: true,
      friendlyName: 'Button Variant',
      enum: buttonVariantOptions,
      defaultValue: 'primary',
      helperText: 'The style of the button: primary (blue), secondary (navy blue - darker than primary), cta (special emphasis)',
    },
    {
      name: 'buttonUrl',
      type: 'string',
      defaultValue: '/process/quiz',
      friendlyName: 'Button URL',
      helperText: 'The destination page when the button is clicked (e.g., /services, /contact, /special-offer)',
    },
    ...getBackgroundColorInput({
      defaultValue: 'White',
    }),
    ...getBackgroundGradientInput({
      backgroundGradientName: 'backgroundGradient',
      backgroundGradientList: backgroundGradientOptions,
    }),
    {
      name: 'backgroundImage',
      type: 'file',
      allowedFileTypes: ['jpeg', 'jpg', 'png', 'webp', 'gif', 'svg'],
      friendlyName: 'Background Image',
      helperText: 'Upload a background image or provide an image URL (optional)',
    },
    ...getPaddingInputs({
      desktopTop: 'large',
      desktopBottom: 'large',
      mobileTop: 'small',
      mobileBottom: 'large',
    }),
  ],
});
